var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ah-product-card-body" }, [
    _c("div", { staticClass: "ah-product-card-category" }, [
      _vm._v("\n    " + _vm._s(_vm.category) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ah-product-card-heading" }, [
      _vm._v("\n    " + _vm._s(_vm.heading) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "ah-product-card-excerpt",
      domProps: { innerHTML: _vm._s(_vm.excerpt) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }